const theme = {
  colors: {},

  font: {
    family: "Poppins",
    weight: {
      thin: 100,
      extraLight: 200,
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
      extraBold: 800,
    },
  },

  media: {
    md: 768,
    sm: 500,
    lg: 968,
    xl: 1440,
  },

  utils: {},
};

export default theme;
